const statuses = [
    "new",
    "in_progress",
    "done"
];

const getTasksByStatus = (unorderedTasks) => {
    const tasksByStatus = unorderedTasks.reduce(
        (acc, task) => {
            acc[task.status].push(task);
            return acc;
        },
        statuses.reduce(
            (obj, status) => ({ ...obj, [status]: [] }),
            {}
        )
    );
    // order each column by index
    statuses.forEach((status) => {
        tasksByStatus[status] = tasksByStatus[status].sort(
            (recordA, recordB) => recordA.index - recordB.index
        );
    });
    return tasksByStatus;
};

export default statuses;
export { getTasksByStatus };